export const triggerBrowserDownload = (blob, fileName) => {
  if (process.env.NODE_ENV === 'test') return;
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return;
  }
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  if (link?.parentNode?.removeChild) link.parentNode.removeChild(link);
};

export const parseFilename = (headers, defaultFileName) => {
  const header = headers?.['content-disposition'];
  if (!header) return defaultFileName;
  const match = header.split('filename=')[1];
  return match ? match.replace(/^"|"$/g, '') : defaultFileName;
};

export const downloadCsvResponse = (response, defaultFileName) =>
  triggerBrowserDownload(new Blob([response.data]), parseFilename(response.headers, defaultFileName));
